
import { reactive, ref,inject,onMounted  } from 'vue'
import { useRoute,useRouter } from 'vue-router'
import {Toast} from 'vant'
import phoneEmail from '../../components/email-phone/index.vue' 
import {loginFn,CommonLogin} from '../../hooks/index'
import Header from '@/components/header/header.vue'
export default { 
  components:{
    phoneEmailVue:phoneEmail, 
    Header
  },
 setup() {
       let info = reactive({id:null})
  onMounted( async()=>{       
          info = getInfo();
        })
    const router = useRouter()
    const route = useRoute()
    const fromDate:any = ref(null)
    const password = ref('');
    const conPassword = ref('');
    
    const passwordVerify = ref(true);
    const isShowPassword = ref(false);
    const isShowConPassword = ref(false);
    
    const registerType = ref(true)
    const loading = ref(false)
       const $http: any = inject('$http')
       // email phone Type切换
    const registerTypeFn = () => {
      registerType.value = !registerType.value
      fromDate.value.verify.email = ''
      fromDate.value.verify.phone = ''
    }
    const verifyLength = ():boolean => {
      return passwordVerify.value = password.value.length>=6? true : false
    }
    const isShowPWFn = () => {
      isShowPassword.value = !isShowPassword.value 
    }
    const isShowConPasswordFn = () => {
      isShowConPassword.value = !isShowConPassword.value 
    }
    
      const phone_or_email_bind = ref(route.query.type);
      const resetPassword = ref(false);
      // 参数
    const  getParamsFn = () =>{
        let params = reactive({
        country_code:"",
        phone:fromDate.value.verify.phone,
        captcha:fromDate.value.verify.code,
        email:fromDate.value.verify.email,
        password:'',
        facebookid:null
      })
      // true 邮箱 验证
      if(registerType.value == true){
          params.email =  fromDate.value.verify.email
          params.captcha =  fromDate.value.verify.code
      }else{
          params.country_code =  fromDate.value.country_code
          params.phone = fromDate.value.verify.phone
          params.captcha = fromDate.value.verify.code
      }
      return params
      }
      // 验证码校验
    const submitFn = async () => {
      if(registerType.value&&(!fromDate.value.verify.email || fromDate.value.isEmailHint)){
          return Toast("Please input a valid email address.")
      }
      if(!registerType.value&&(!fromDate.value.verify.phone || fromDate.value.isPhoneHint)){
          return Toast("Please input valid phone number.")
      }
      if(!fromDate.value.verify.code) {
          return Toast("Please enter the verification code.")
      }
        loading.value = true
        
    let params =  getParamsFn()
      let ret = await $http.checkCaptcha(params);
                loading.value = false
                if (ret.code == 200){
                    if(phone_or_email_bind.value=='bind'){
                        
                        let ret = await  $http.bind(params);
                        if(ret.code == 200){
                             resetPassword.value = true;
                        }else{
                             Toast(ret.message) 
                        }
                    }else{
                         resetPassword.value = true;
                    }
                    
                }else{
                    Toast(ret.message)
                }
    }
   // 重置密码提交
   const resetPasswordFn =  async () => {
      if(!password.value || password.value.length<6){
            return Toast("Minimum 6 characters required.")
        }
        if(password.value!= conPassword.value){
          return Toast("The two passwords don't match.")
      }
              let params =  getParamsFn()
              params.password = password.value
                if(phone_or_email_bind.value=='register'){
                    if (info.id){
                         params.facebookid = info.id;  
                   }
                    let ret = await $http.register(params)
                    if (ret.code == 200){
                        loginFn(ret.data, $http,'register');
                    }else{
                        Toast(ret.message)
                    }
                }else{
                    let ret = await $http.findPassword(params)
                    if (ret.code == 200){
                        Toast(ret.message) 
                        setTimeout(()=>{
                        CommonLogin({ username:params.email?params.email:params.phone,password:password.value},$http,'login')
                        },1500)
                    }else{
                        Toast(ret.message)
                    }
              }
      }
    return { registerType,submitFn,fromDate,loading,registerTypeFn,isShowPWFn,verifyLength,passwordVerify,password,isShowPassword,resetPassword,resetPasswordFn,phone_or_email_bind ,isShowConPasswordFn,conPassword,isShowConPassword,Toast};
  },

}
function getInfo () {
            let info = localStorage.getItem('info')
            if (!info) return
             JSON.parse(info);
            return JSON.parse(info)
        }
